import RouteSet from 'src/routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './style.scss';

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false, // window focus 설정
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <RouteSet />
    </QueryClientProvider>
  );
}
export default App;
